document.addEventListener('DOMContentLoaded', () => {
  const MOBILE_BREAKPOINT = 768;
  const menuBlocks = document.querySelectorAll('.footer__menu-block');

  if (!menuBlocks.length) return;

  menuBlocks.forEach((block) => {
    const heading = block.querySelector('.js-toggle-footer-mobile-menu');
    const content = block.querySelector('.js-mobile-menu-content');

    if (!heading || !content) return;

    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');

    const openMenu = () => {
      block.classList.add('is-open');
      content.style.maxHeight = content.scrollHeight + 'px';
      heading.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      block.classList.remove('is-open');
      content.style.maxHeight = null;
      heading.setAttribute('aria-expanded', 'false');
    };

    const toggleMenu = () => {
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;

      if (block.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    };

    heading.addEventListener('click', toggleMenu);

    heading.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleMenu();
      }
    });

    const handleResize = () => {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        if (!block.classList.contains('is-open')) {
          content.style.maxHeight = null;
          heading.setAttribute('aria-expanded', 'false');
        }
      } else {
        content.style.maxHeight = null;
        block.classList.remove('is-open');
        heading.setAttribute('aria-expanded', 'false');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
  });
});